import { Divider, Grid } from '@mui/material';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { Residence } from 'front-office/view-models/release-id-card/residence';
import { DatePicker } from '@mui/lab';
import Municipality from './municipality';
import Toponymy from './toponymy';
import CivicNumber from './civic-number';
import CivicInternal from './civic-internal';
import ForeignLocation from './foreign-location';

interface FormProps {
  onChange: (key: keyof Residence, value: Residence[keyof Residence]) => void;
  values?: Residence;
}

const disabled = true; // section disabled

const FormComponent = ({ onChange, values }: FormProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Tipo residenza"
          fullWidth
          aria-label="Tipo residenza"
          disabled={disabled}
          value={values?.type || ''}
          onChange={(event) => {
            onChange('type', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <DatePicker
          label="Decorrenza residenza"
          aria-label="Decorrenza residenza"
          value={values?.effectiveDate || null}
          onChange={(date) => {
            onChange('effectiveDate', date);
          }}
          renderInput={(params) => (
            <PmiTextField {...params} disabled={disabled} fullWidth helperText="" />
          )}
        />
      </Grid>
      <Municipality onChange={onChange} values={values} disabled={disabled} />
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Toponymy onChange={onChange} values={values} disabled={disabled} />
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <CivicNumber onChange={onChange} values={values} disabled={disabled} />
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <CivicInternal onChange={onChange} values={values} disabled={disabled} />
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <ForeignLocation onChange={onChange} values={values} disabled={disabled} />
    </Grid>
  );
};

FormComponent.displayName = 'form residence';

const Form = memo(FormComponent);

export default Form;
